import createUseService from '@/utils/create-use-service';

import service from './service';

export const {
  useServiceError: useServiceStripeError,
  useServiceActions: useServiceStripeActions,
} = createUseService(service, 'stripe');
